export const NewClassCommentActionTypes = {
    TOGGLE_CLASS_COMMENT_PAGE_HIDDEN: 'TOGGLE_CLASS_COMMENT_PAGE_HIDDEN',
    CLASS_COMMENT_MESSAGE: 'CLASS_COMMENT_MESSAGE',
};